// extracted by mini-css-extract-plugin
export default {"metadataContainer":"MetadataContainer-module__metadataContainer--_O_j_"};